<zimmerer-route-ion-wrapper class="ion-page">

  <div class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">
    <div class="main-col withBottomPadding" style="position: relative;" [class.withTopPadding]="MobileService.isMobile"
      [class.noSlider]="!hasSliderImages" fxLayout="column" fxLayoutGap="20px">

      <image-slider [fxHide]="!hasSliderImages" [page]="'wiki'" fxHide.lt-lg></image-slider>

      <div *ngIf="!userService.isLoggedIn" class="click-login-wall" appLoginClickGuard></div>

      <iframe [src]="environment.backendUrl+'/storage/BSWALSzt/wrl-z1/wrl-zimmerer.htm' | safeURL"
        style="border:none; overflow:hidden;" scrolling="yes" frameborder="0" allowTransparency="true"
        allow="encrypted-media" style="height: 1200px; width: 100%;">
      </iframe>
    </div>
  </div>

  <app-footer></app-footer>

</zimmerer-route-ion-wrapper>